import './polyfills'
// Validation plugin used to validate forms
import es from 'vee-validate/dist/locale/es';
import VeeValidate, { Validator } from 'vee-validate';
// A plugin file where you could register global components used across the app
import GlobalComponents from './globalComponents'
// A plugin file where you could register global directives
import GlobalDirectives from './globalDirectives'
import Logger from './logger'
// Sidebar on the right. Used as a local plugin in DashboardLayout.vue
import SideBar from './components/SidebarPlugin'

// element ui language configuration
import lang from 'element-ui/lib/locale/lang/es'
import locale from 'element-ui/lib/locale'
locale.use(lang)

// asset imports
import 'bootstrap/dist/css/bootstrap.css'
import './assets/sass/light-bootstrap-dashboard.scss'
//import './assets/css/demo.css'
import './assets/sass/element-variables.scss'

export default {
  async install (Vue) {
    Vue.use(GlobalComponents)
    Vue.use(GlobalDirectives)
    Vue.use(SideBar)
    Vue.use(VeeValidate, {
      fieldsBagName: 'veeFields'
    })
    // Install Spanish locale.
    Validator.localize('es', es)
    Vue.use(Logger)
  }
}
